import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import css from './BecomeAnExpertLink.module.css';

export const BecomeAnExpertLink = (props) => {
  const { buttonClass, labelClass } = props;
  return (
    <NamedLink name="SignupPageByUserType" params={{ userType: 'expert' }} className={classNames(css.topbarLink, buttonClass)}>
      <span className={classNames(css.topbarLinkLabel, css.special, labelClass)}>
        <FormattedMessage id="TopbarDesktop.becomeAnExpert" />
      </span>
    </NamedLink>
  );
};